import { render } from "./imgEditor.vue?vue&type=template&id=17acd5ff"
import script from "./imgEditor.vue?vue&type=script&lang=js"
export * from "./imgEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__